module.exports = __webpack_public_path__ + "static/four-5f63f189107853f98ba635f09a724940.png";